<template>
  <q-layout view="lHh Lpr fff" class="bg-grey-1 main-layout">
    <!--<q-header class="bg-grey-1 text-grey-8" height-hint="64">-->
    <!--<img class="logo" src="statics/charttt-logo.svg">-->
    <!--</q-header>-->
    <q-page-container class="page-container full-height">
      <router-view />
    </q-page-container>
  </q-layout>
  <FormDataForm
    url="https://forms.form-data.com/JhGXbzqZDcgsJcXZQREo/-qFDlFndcddQ_4/embed"
    mode="sidebar"
    trigger="fab"
    debug
    global-prop-name="joy"
    :fab="{ color: '#ffffff', zIndex: '99999', ackground: 'rgb(240, 250, 240)', width: '80px', onOpenMode: 'hide', side: 'right', icon: 'hand-up-help', iconSize: '100%', iconOnly: 'true' }"
    :sidebar="{side: 'right', overlay: false, width: '360px'}"
  />
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import { FormDataForm } from '@formdata/vue';
import {useStudioStore} from "stores/studio";
import {useQuasar} from 'quasar'

export default defineComponent({
  name: 'AuthLayout',
  components: {
    FormDataForm
  },
  setup () {
    const studioStore = useStudioStore()
    onMounted(() => {
      if (studioStore.publishFormStorageKey) {
        studioStore.updatePublishFormNotification({
          message: '<span class="text-h5">You\'re just 2 steps away from having your form live 🎉</span>',
          caption: '<span class="text-h6">Login or register to continue!</span>',
        })
      }
    })
    return {
    }
  }
})
</script>
